import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCreateLoading,
  getLoadingWeekly,
  getTagPreferences,
  getWeeklyPreferencePreview
} from '../redux/selector';
import {
  get_preview_weekly_preference,
  get_tag_preferences,
  update_tag_preference
} from '../redux/reducer';
import moment from 'moment';
import { FaSpinner } from 'react-icons/fa6';
import ViewWeeklyPreferenceModal from './view-weekly-preference-modal';
import TagPreferencesModal from './tag-preferences-modal';
import { getTags } from '@app/pages/meal-tags/redux/selectors';
import { get_tags } from '@app/pages/meal-tags/redux/reducers';
import toast from 'react-hot-toast';

const WeeklyMealPreferences = () => {
  const preferences = useSelector(getWeeklyPreferencePreview);
  const loading = useSelector(getLoadingWeekly);
  const dispatch = useDispatch();
  const [content, setContent] = useState(null);
  const [show, setShow] = useState(false);
  const [hide, setHide] = useState(false);
  const tagPreferences = useSelector(getTagPreferences);
  const [selectedTags, setSelectedTags] = useState([]);
  const tags = useSelector(getTags);
  const creating = useSelector(getCreateLoading);

  useEffect(() => {
    dispatch(get_preview_weekly_preference());
    dispatch(get_tag_preferences());
    dispatch(get_tags());
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(tagPreferences?.tags)) {
      const tagIds = tagPreferences.tags.map((tag) =>
        typeof tag === 'object' ? tag._id : tag
      );
      setSelectedTags(tagIds);
    }
  }, [tagPreferences]);

  const handleTagToggle = (tagId) => {
    setSelectedTags((prev) => {
      if (prev.includes(tagId)) {
        return prev.filter((id) => id !== tagId);
      } else {
        return [...prev, tagId];
      }
    });
  };

  const handleSubmit = () => {
    if (selectedTags?.length === 0) {
      toast.error('Please select at least one tag preference');
      return;
    }
    dispatch(
      update_tag_preference({
        tags: selectedTags,
        goals: tagPreferences?.goals || 'general_health'
      })
    );
  };

  return (
    <div>
      <TagPreferencesModal
        isOpen={hide}
        onClose={() => {
          setHide(!hide);
        }}
        tags={tags}
        selectedTags={selectedTags}
        handleTagToggle={handleTagToggle}
        handleSubmit={handleSubmit}
        creating={creating}
      />
      <ViewWeeklyPreferenceModal
        isOpen={show}
        content={content}
        onClose={() => {
          setShow(!show);
          setContent(false);
        }}
      />
      <div className="p-6 border-b border-[#E7E7E9] flex items-center justify-between">
        <p className="text-base font-semibold">Weekly Meal Peferences</p>
        <button
          className="bg-[#549a9a] text-white text-[16px] font-[600] p-3 rounded-sm"
          onClick={() => setHide(!hide)}
        >
          Update Meal Peference
        </button>
      </div>
      {loading ? (
        <div className="grid place-items-center h-screen">
          <FaSpinner className="animate-spin" size={30} />
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6 p-4 md:grid-cols-2 lg:grid-cols-4">
          {Array.isArray(preferences) &&
            preferences?.map((meal, idx) => (
              <MealPlanCard
                entry={meal}
                key={idx}
                handleSelect={() => {
                  setContent(meal);
                  setShow(!show);
                }}
              />
            ))}
        </div>
      )}
    </div>
  );
};

export default WeeklyMealPreferences;

const MealPlanCard = ({ entry, handleSelect }) => {
  const { meal, type, date } = entry;
  return (
    <div
      className="p-4 border border-[#E7E7E9] rounded-[16px] cursor-pointer flex flex-col justify-between gap-3"
      onClick={handleSelect}
    >
      <div className="flex-1 space-y-3">
        <header className="flex justify-between items-center">
          <span className="font-medium capitalize">{type}</span>
          <span className="font-medium">{moment(date).format('DD, MMM, YYYY')}</span>
        </header>

        {meal?.image ? (
          <img
            src={meal?.image}
            alt={meal?.name}
            className="h-[200px] object-cover w-full rounded-md"
          />
        ) : (
          <div className=" h-[200px] rounded-md w-full border flex justify-center items-center bg-gray-100">
            No Image
          </div>
        )}
      </div>
      <div className="space-y-2">
        <p className="text-lg font-bold">{meal?.name}</p>
        <p className="text-sm text-gray-500 line-clamp-2">{meal?.description}</p>
      </div>
    </div>
  );
};
